'use strict';
function convertToLabelValuePair(arrayToConvert) {
	if (arrayToConvert == null) {
		return [];
	}
	let labelValuePairArray = [];
	labelValuePairArray = Object.keys(arrayToConvert).map(key => ({
		label: arrayToConvert[key],
		text: arrayToConvert[key],
		value: key
	}));
	return labelValuePairArray;
}
export default convertToLabelValuePair;
